var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasUnbanId)?_c('p',[_vm._v("\n    unban id unknown\n  ")]):_vm._e(),(_vm.hasUnbanId)?_c('player-unban-link',{attrs:{"playerId":_vm.action.playerId,"unbanId":_vm.action.unbanId,"lable":"unban"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }